module.exports = __webpack_public_path__ + "static/media/d_3bhk_2.78eddb83.jpg";